import { request } from '../http';

// 经 coop-api 中继获取 admanager 当前用户信息(含可切换组织/角色,服务端同时激活上下文)
export const getUserInfo = () => request('/api/user_info');
